import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "index" }

import { ref, provide, readonly, defineComponent } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexIndex',
  setup(__props) {

// import Top from "@/views/pageModel/index/top/TopIndex.vue";
// import Bottom from "@/views/pageModel/index/bottom/BottomIndex.vue";
const only = ref("readonly!");
// defineComponent({ Top });
provide("message", "hellow!");
provide("only", readonly(only));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, { class: "index-body" })
  ]))
}
}

})